// import React from "react";
// import styles from "./ProductInfo.module.css";
// import { Brand } from "../Types/product.types";
// import { Tooltip } from "primereact/tooltip";
// import { Toast } from "primereact/toast";
// import { useRef } from "react";
// interface ProductInfoProps {
//   product_id: number;

//   brand: {
//     name: string;
//     thumbnail: string;
//     url: string;
//   };
//   // isShowPrice?: boolean;
//   isLoggedIn?: boolean;
//   isShowPrice?: boolean;
//   product_feature: {
//     product_feature_id: number;
//     feature: {
//       name: string;
//       url: string;
//     };
//   }[];
//   name: string;
//   // sku: string;
//   product_price: number;
//   product_offer_price: number;
//   rating: number;
//   reviewCount: number;
//   image: string;
//   compatible_vehicles: string;
//   tags: string[];
//   document_as_product: [
//     {
//       document: {
//         file_path: string;
//       };
//     },
//   ];
//   onAddToCart?: () => void;
//   onBuyNow?: () => void;
// }

// interface ProductCardProps {
//   product: ProductInfoProps;
// }
// const ProductInfo: React.FC<ProductInfoProps> = ({
//   brand,
//   name,
//   compatible_vehicles,
//   product_price,
//   product_offer_price,
//   product_feature,
//   isLoggedIn,
//   isShowPrice,

//   onAddToCart,
//   onBuyNow,
// }) => {
//   // const hasDiscount =
//   //   product_offer_price > 0 && product_offer_price < product_price;
//   // const discountPercent = hasDiscount
//   //   ? Math.round(((product_price - product_offer_price) / product_price) * 100)
//   //   : 0;
//   const safeProductPrice = Number(product_price ?? 0);
//   const safeOfferPrice = Number(product_offer_price ?? 0);

//   const hasDiscount = safeOfferPrice > 0;

//   const discountPercent = hasDiscount
//     ? Math.round(((safeProductPrice - safeOfferPrice) / safeProductPrice) * 100)
//     : 0;
//   const toast = useRef<Toast>(null);
//   const handleAddCart = async () => {
//     if (!onAddToCart) return;

//     await onAddToCart();

//     toast.current?.show({
//       severity: "success",
//       summary: "Success",
//       detail: "Product added to cart successfully",
//       life: 3000,
//     });
//   };
//   return (
//     <>
//       <Toast ref={toast} />
//       <div className={styles.info}>
//         <div className={styles.brandRow}>
//           <img
//             src={brand?.thumbnail}
//             alt={brand?.name}
//             className={styles.brandLogo}
//           />
//         </div>
//         <h1 className={styles.title}>{name}</h1>
//         {compatible_vehicles && (
//           <div className={styles.vehiclesBox}>
//             <p className={styles.vehiclesHeading}>Compatible Vehicles</p>

//             <div
//               className={styles.vehicleText}
//               dangerouslySetInnerHTML={{
//                 __html: compatible_vehicles,
//               }}
//             />
//           </div>
//         )}
//         <Tooltip target=".feature-tooltip" position="top" />

//         <div className={styles.featureContainer}>
//           {product_feature?.map((item) => (
//             <div
//               key={item.product_feature_id}
//               className={`${styles.featureItem} feature-tooltip`}
//               data-pr-tooltip={item.feature.name}
//             >
//               <img
//                 src={item.feature.url}
//                 alt={item.feature.name}
//                 className={styles.featureImage}
//               />
//             </div>
//           ))}
//         </div>
//         {/* <div className={styles.featureContainer}>
//         {product_feature?.map((item) => (
//           <div key={item.product_feature_id} className={styles.featureItem}>
//             <img
//               src={item.feature.url}
//               alt={item.feature.name}
//               className={styles.featureImage}
//             />
//             <span className={styles.featureName}></span>
//             tooltip={item.feature.name}
//             tooltipOptions={{ position: "top" }}
//           </div>
//         ))}
//       </div> */}
//         {/* <div className={styles.priceRow}>
//           <span className={styles.offerPrice}>
//             ₹{" "}
//             {product_offer_price > 0
//               ? product_offer_price?.toLocaleString("en-IN")
//               : product_price?.toLocaleString("en-IN")}
//           </span>
//           {hasDiscount && (
//             <>
//               <span className={styles.originalPrice}>
//                 ₹{product_price?.toLocaleString("en-IN")}
//               </span>
//               <span className={styles.discountBadge}>
//                 {discountPercent}% OFF
//               </span>
//             </>
//           )}
//           <p className={styles.taxText}>(Incl. all taxes)</p>
//         </div> */}
//         {/* <div className={styles.priceRow}>
//           {!isShowPrice ? (
//             // Price hidden
//             <span className={styles.offerPrice}>₹ ***</span>
//           ) : (
//             // Price visible
//             <>
//               <span className={styles?.offerPrice}>
//                 ₹{" "}
//                 {product_offer_price > 0
//                   ? product_offer_price.toLocaleString("en-IN")
//                   : product_price.toLocaleString("en-IN")}
//               </span>

//               {hasDiscount && (
//                 <>
//                   <span className={styles?.originalPrice}>
//                     ₹{product_price.toLocaleString("en-IN")}
//                   </span>

//                   <span className={styles?.discountBadge}>
//                     {discountPercent}% OFF
//                   </span>
//                 </>
//               )}
//             </>
//           )}

//           <p className={styles?.taxText}>(Incl. all taxes)</p>
//         </div> */}
//         {/* <div className={styles.priceRow}>
//           {!isShowPrice ? (
//             <span className={styles.offerPrice}>₹ ***</span>
//           ) : (
//             <>
//               <span className={styles.offerPrice}>
//                 ₹{" "}
//                 {(safeOfferPrice > 0
//                   ? safeOfferPrice
//                   : safeProductPrice
//                 ).toLocaleString("en-IN")}
//               </span>

//               {hasDiscount && (
//                 <>
//                   <span className={styles.originalPrice}>
//                     ₹{safeProductPrice.toLocaleString("en-IN")}
//                   </span>

//                   <span className={styles.discountBadge}>
//                     {discountPercent}% OFF
//                   </span>
//                 </>
//               )}
//             </>
//           )}

//           <p className={styles.taxText}>(Incl. all taxes)</p>
//         </div> */}
//         {/* <div className={styles.priceWrapper}>
//           {!isShowPrice ? (
//             <p className={styles.offerPrice}>₹ ***</p>
//           ) : hasDiscount ? (
//             <>
//               <p className={styles.offerPrice}>
//                 ₹{safeOfferPrice.toLocaleString("en-IN")}
//               </p>

//               <p className={styles.originalPrice}>
//                 ₹{safeProductPrice.toLocaleString("en-IN")}
//               </p>

//               <span className={styles.discountBadge}>
//                 {discountPercent}% OFF
//               </span>
//             </>
//           ) : (
//             <p className={styles.offerPrice}>
//               ₹{safeProductPrice.toLocaleString("en-IN")}
//             </p>
//           )}

//           <p className={styles.taxText}>(Inc. of Taxes)</p>
//         </div> */}
//         <div className={styles.priceRow}>
//           {!isLoggedIn ? (
//             // Guest → always show actual price
//             <span className={styles.offerPrice}>
//               ₹{safeProductPrice.toLocaleString("en-IN")}
//             </span>
//           ) : !isShowPrice ? (
//             // Logged in → price not allowed
//             <span className={styles.offerPrice}>₹ ***</span>
//           ) : hasDiscount ? (
//             // Logged in → price allowed + discount
//             <>
//               <span className={styles.offerPrice}>
//                 ₹{safeOfferPrice.toLocaleString("en-IN")}
//               </span>

//               <span className={styles.originalPrice}>
//                 ₹{safeProductPrice.toLocaleString("en-IN")}
//               </span>

//               <span className={styles.discountBadge}>
//                 {discountPercent}% OFF
//               </span>
//             </>
//           ) : (
//             // Logged in → price allowed + no discount
//             <span className={styles.offerPrice}>
//               ₹{safeProductPrice.toLocaleString("en-IN")}
//             </span>
//           )}

//           <p className={styles.taxText}>(Incl. all taxes)</p>
//         </div>
//         <div className={styles?.actions}>
//           <button
//             type="button"
//             className={styles.addToCartBtn}
//             onClick={handleAddCart}
//           >
//             Add to Cart
//           </button>
//           <button type="button" className={styles.buyNowBtn} onClick={onBuyNow}>
//             Buy Now
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ProductInfo;
import React, { useRef, useState } from "react";
import styles from "./ProductInfo.module.css";
import { Tooltip } from "primereact/tooltip";
import { Toast } from "primereact/toast";
import AccountTypeModal, { AccountType } from "../Login_Page/AccountTypeModal";
import LoginModal from "../Login_Page/LoginModal";

interface ProductInfoProps {
  product_id: number;

  brand: {
    name: string;
    thumbnail: string;
    url: string;
  };
  isLoggedIn?: boolean;
  isShowPrice?: boolean;
  product_feature: {
    product_feature_id: number;
    feature: {
      name: string;
      url: string;
    };
  }[];
  name: string;
  product_price: number;
  product_offer_price: number;
  rating: number;
  reviewCount: number;
  image: string;
  compatible_vehicles: string;
  tags: string[];
  document_as_product: [
    {
      document: {
        file_path: string;
      };
    },
  ];
  onAddToCart?: () => void | Promise<void>;
  onBuyNow?: () => void;
}

const ProductInfo: React.FC<ProductInfoProps> = ({
  brand,
  name,
  compatible_vehicles,
  product_price,
  product_offer_price,
  product_feature,
  isLoggedIn,
  isShowPrice,
  onAddToCart,
  onBuyNow,
}) => {
  const safeProductPrice = Number(product_price ?? 0);
  const safeOfferPrice = Number(product_offer_price ?? 0);

  const hasDiscount = safeOfferPrice > 0 && safeProductPrice > 0 && safeOfferPrice<safeProductPrice;

  const discountPercent = hasDiscount
    ? Math.round(((safeProductPrice - safeOfferPrice) / safeProductPrice) * 100)
    : 0;

  const toast = useRef<Toast>(null);

  // ---- Login popup state (same as ProductCard) ----
  const [authStep, setAuthStep] = useState<"none" | "accountType" | "login">(
    "none",
  );
  const [selectedAccountType, setSelectedAccountType] =
    useState<AccountType>("customer");
  const [pendingAction, setPendingAction] = useState<null | "cart" | "buy">(
    null,
  );

  // Returns true if logged in, otherwise opens the login popup and returns false
  const requireLogin = () => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");

    if (authTokens?.user?.id) {
      return true; // already logged in
    }

    setAuthStep("accountType");
    return false; // not logged in, caller should stop
  };

  const handleAddCart = async () => {
    if (!requireLogin()) {
      setPendingAction("cart");
      return;
    }

    if (!onAddToCart) return;

    await onAddToCart();

    toast.current?.show({
      severity: "success",
      summary: "Success",
      detail: "Product added to cart successfully",
      life: 3000,
    });
  };

  const handleBuyNow = () => {
    if (!requireLogin()) {
      setPendingAction("buy");
      return;
    }

    onBuyNow?.();
  };

  return (
    <>
      <Toast ref={toast} />

      {/* Login popups */}
      {authStep === "accountType" && (
        <AccountTypeModal
          visible={authStep === "accountType"}
          onHide={() => {
            setAuthStep("none");
            setPendingAction(null);
          }}
          onSelect={(type) => {
            setSelectedAccountType(type);
            setAuthStep("login");
          }}
        />
      )}

      <LoginModal
        visible={authStep === "login"}
        onHide={() => {
          setAuthStep("none");
          setPendingAction(null);
        }}
        accountType={selectedAccountType}
        onLoginSuccess={() => {
          setAuthStep("none");

          // Continue what the user was trying to do before login
          if (pendingAction === "cart") handleAddCart();
          if (pendingAction === "buy") handleBuyNow();

          setPendingAction(null);
        }}
      />

      <div className={styles.info}>
        <div className={styles.brandRow}>
          <img
            src={brand?.thumbnail}
            alt={brand?.name}
            className={styles.brandLogo}
          />
        </div>

        <h1 className={styles.title}>{name}</h1>

        {compatible_vehicles && (
          <div className={styles.vehiclesBox}>
            <p className={styles.vehiclesHeading}>Compatible Vehicles</p>

            <div
              className={styles.vehicleText}
              dangerouslySetInnerHTML={{
                __html: compatible_vehicles,
              }}
            />
          </div>
        )}

        <Tooltip target=".feature-tooltip" position="top" />

        <div className={styles.featureContainer}>
          {product_feature?.map((item) => (
            <div
              key={item.product_feature_id}
              className={`${styles.featureItem} feature-tooltip`}
              data-pr-tooltip={item.feature.name}
            >
              <img
                src={item.feature.url}
                alt={item.feature.name}
                className={styles.featureImage}
              />
            </div>
          ))}
        </div>

        <div className={styles.priceRow}>
          {!isLoggedIn ? (
            // Guest → always show actual price
            <span className={styles.offerPrice}>
              ₹{safeProductPrice.toLocaleString("en-IN")}
            </span>
          ) : !isShowPrice ? (
            // Logged in → price not allowed
            <span className={styles.offerPrice}>₹ ***</span>
          ) : hasDiscount ? (
            // Logged in → price allowed + discount
            <>
              <span className={styles.offerPrice}>
                ₹{safeOfferPrice.toLocaleString("en-IN")}
              </span>

              <span className={styles.originalPrice}>
                ₹{safeProductPrice.toLocaleString("en-IN")}
              </span>

              <span className={styles.discountBadge}>
                {discountPercent}% OFF
              </span>
            </>
          ) : (
            // Logged in → price allowed + no discount
            <span className={styles.offerPrice}>
              ₹{safeProductPrice.toLocaleString("en-IN")}
            </span>
          )}

          <p className={styles.taxText}>(Incl. all taxes)</p>
        </div>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.addToCartBtn}
            onClick={handleAddCart}
          >
            Add to Cart
          </button>
          <button
            type="button"
            className={styles.buyNowBtn}
            onClick={handleBuyNow}
          >
            Buy Now
          </button>
        </div>
      </div>
    </>
  );
};

export default ProductInfo;
